import { tenant } from "../../tenant";

export const portalConfig = {
  methods: [
    { id: "scan", icon: "scan" },
    { id: "upload", icon: "upload" },
    { id: "credential", icon: "id" },
  ],
  contact: tenant.branding?.contact || {
    email: "",
    phone: "",
    address: "",
  },
  footer: {
    linkHrefs: ["#", "#", "#", "#", "#"],
    documentationHrefs: ["#", "#", "#", "#"],
  },
};
